export class PermissionModel {
  permission: boolean;
  deny: boolean;

  constructor() {
    this.permission = false;
    this.deny = false;
  }
}
